import { defineMessages } from 'react-intl';

export default defineMessages({
  pending: 'Transaction(s) Pending',
  confirmed: 'Success!',
  failed: 'Transaction(s) Failed',
  dashboard: 'Dashboard',
});
